import { Link } from 'gatsby';
import tw from 'twin.macro';
import SEO from '../components/seo';
import ServiceStatus from '../components/status';
import LandingLayout from './landing';

type Category = 'service' | 'document' | 'about' | 'blog';
interface CategoryAttribute {
  name: string;
  to: string;
}
const CategoryMap: Record<Category, CategoryAttribute> = {
  service: {
    name: '解决方案',
    to: '/service',
  },
  document: {
    name: '文档库',
    to: '/document',
  },
  about: {
    name: '了解我们',
    to: '/about',
  },
  blog: {
    name: '博客',
    to: '/blog',
  },
};

interface ArticleLayoutProps {
  category?: Category;
  title?: string;
  subtitle?: string;
  children?: React.ReactNode;
}

const TitleCotainer = tw.div`flex flex-col items-center w-full py-6 md:py-10 bg-gradient-to-br from-purple-500 to-purple-700`;
const CategoryInnerContainer = tw(
  Link,
)`max-w-screen-lg px-6 py-1.5 mb-2 md:mb-4 text-sm md:text-base text-white bg-black hover:shadow-lg cursor-pointer`;
const TitleInnerContainer = tw.div`max-w-screen-lg px-6 text-xl md:text-3xl text-white font-bold text-center`;
const SubtitleInnerContainer = tw.div`max-w-screen-lg px-6 mt-2 md:mt-4 text-sm md:text-base text-gray-200 font-light text-center`;
const Container = tw.div`mx-auto px-8 py-8 max-w-screen-md text-justify`;

const ArticleLayout: React.FC<ArticleLayoutProps> = ({ category, title, subtitle, children }) => (
  <LandingLayout>
    <SEO title={title} />
    <TitleCotainer>
      {category && (
        <CategoryInnerContainer to={CategoryMap[category].to}>
          {CategoryMap[category].name}
        </CategoryInnerContainer>
      )}
      <TitleInnerContainer>{title}</TitleInnerContainer>
      {subtitle && <SubtitleInnerContainer>{subtitle}</SubtitleInnerContainer>}
    </TitleCotainer>
    <Container>{children}</Container>
    <ServiceStatus />
  </LandingLayout>
);

export default ArticleLayout;
